"use client";

import { Check, Copy, Share2 } from "lucide-react";
import { useState } from "react";
import { trackArticleShare } from "@/lib/analytics";

type ShareMethod = Parameters<typeof trackArticleShare>[0]["method"];

export function ArticleShareActions({
  articleSlug,
  articleTitle,
}: {
  articleSlug: string;
  articleTitle: string;
}) {
  const [copied, setCopied] = useState(false);

  function articleUrl() {
    return `${window.location.origin}/article/${articleSlug}`;
  }

  function track(method: ShareMethod) {
    trackArticleShare({ articleSlug, method });
  }

  async function shareNative() {
    const url = articleUrl();
    if (navigator.share) {
      await navigator.share({ title: articleTitle, url });
      track("native");
      return;
    }
    await navigator.clipboard.writeText(url);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
    track("copy_link");
  }

  async function copyLink() {
    await navigator.clipboard.writeText(articleUrl());
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
    track("copy_link");
  }

  function openShare(method: Extract<ShareMethod, "x" | "facebook">, url: string) {
    track(method);
    window.open(url, "_blank", "noopener,noreferrer,width=640,height=520");
  }

  return (
    <div className="mt-5 flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={() => void shareNative()}
        className="inline-flex h-9 items-center gap-2 rounded-lg border border-zinc-200 bg-white px-3 text-xs font-black uppercase text-zinc-700 transition hover:border-[#A4243B] hover:text-[#A4243B]"
      >
        <Share2 size={14} aria-hidden="true" />
        Megosztás
      </button>
      <button
        type="button"
        onClick={() => void copyLink()}
        className="inline-flex h-9 items-center gap-2 rounded-lg border border-zinc-200 bg-white px-3 text-xs font-black uppercase text-zinc-700 transition hover:border-[#A4243B] hover:text-[#A4243B]"
      >
        {copied ? <Check size={14} aria-hidden="true" /> : <Copy size={14} aria-hidden="true" />}
        Link
      </button>
      <button
        type="button"
        onClick={() => openShare("x", `https://twitter.com/intent/tweet?url=${encodeURIComponent(articleUrl())}&text=${encodeURIComponent(articleTitle)}`)}
        className="inline-flex h-9 items-center rounded-lg border border-zinc-200 bg-white px-3 text-xs font-black uppercase text-zinc-700 transition hover:border-[#A4243B] hover:text-[#A4243B]"
      >
        X
      </button>
      <button
        type="button"
        onClick={() => openShare("facebook", `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(articleUrl())}`)}
        className="inline-flex h-9 items-center gap-2 rounded-lg border border-zinc-200 bg-white px-3 text-xs font-black uppercase text-zinc-700 transition hover:border-[#A4243B] hover:text-[#A4243B]"
      >
        <Share2 size={14} aria-hidden="true" />
        Facebook
      </button>
    </div>
  );
}
